import Button from "./Button";

const ButtonList = (props) => {
  let itemKeys = props.list;
  
  return (
    <>
      {itemKeys.map((key) => {
        if (key.length >= 5) return;
        let item = props.category[key];
        let ButtonProps = {
          label: item.title,
          id: item.id,
          isActive: item.isActive,
          addClass: props.addClass,
          ariaPressed: props.ariaPressed,
        };
        return <Button {...ButtonProps} onClick={props.onClick} />;
      })}
    </>
  );
};

export default ButtonList;
